import { IConfirmConfig } from '@covalent/core/dialogs';

export const NIBRAS_DIALOG_CONFIG = {
  panelClass: ['nibras-dialog-container'],
  resizable: 'resizable',
  noContentPaddingClass: 'no-content-padding'
};

export const NIBRAS_CONFIRM_DIALOG_PARAMS: Partial<IConfirmConfig> = {
  title: 'Confirm',
  cancelButton: 'Cancel', //OPTIONAL, defaults to 'CANCEL'
  acceptButton: 'OK' //OPTIONAL, defaults to 'ACCEPT'
};

export const NIBRAS_CONFIRM_DIALOG_CONFIG = {
  panelClass: 'nibras-confirm-dialog-container',
  minWidth: '300px',
  //width: '300px',
  disableClose: false,
  ...NIBRAS_CONFIRM_DIALOG_PARAMS
};

export const NIBRAS_ALTER_DIALOG_CONFIG = {
  panelClass: 'nibras-confirm-dialog-container',
  minWidth: '300px',
  width: '300px',
  disableClose: false,
  cancelButton: 'OK' //OPTIONAL, defaults to 'CANCEL'
};
